import Nanobar from 'nanobar';

const nanobar = new Nanobar()

export default nanobar;